import { FontAwesome, Ionicons, MaterialIcons } from "@expo/vector-icons";
import DateTimePicker from "@react-native-community/datetimepicker";
import { useRoute } from "@react-navigation/core";
import dayjs from "dayjs";
import * as DocumentPicker from "expo-document-picker";
import * as FileSystem from "expo-file-system";
import {
	Actionsheet,
	Box,
	Button,
	FormControl,
	Icon,
	IconButton,
	Input,
	ScrollView,
	Select,
	Stack,
	Text,
	useDisclose,
	useMediaQuery,
	useTheme,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, Image, Platform, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { useDispatch, useSelector } from "react-redux";
// API
import disputeClaim from "../../common/disputeClaim";
import AppCamera from "../../components/camera/AppCamera";
import AppScanCamera from "../../components/camera/AppScanCamera";
import ErrorToast from "../../components/ErrorToast";
import InfoToast from "../../components/InfoToast";
import Loader from "../../components/Loader";
import SuccessToast from "../../components/SuccessToast";
import Constants from "../../utils/Constants";
import { isWeb } from "../../utils/utils";

// import "../../utils/global.css";

// import { DatePicker } from "react-rainbow-components";

const DatePicker = isWeb()
	? require("react-rainbow-components").DatePicker
	: null;
const Application = isWeb()
	? require("react-rainbow-components").Application
	: null;

const { width, height } = Dimensions.get("window");

const DisputeClaim = ({ navigation }) => {
	const { isOpen, onOpen, onClose } = useDisclose();
	const {
		isOpen: isOpenBarCode,
		onOpen: onOpenBarCode,
		onClose: onCloseBarCode,
	} = useDisclose();
	const {
		isOpen: isOpenIMG,
		onOpen: onOpenIMG,
		onClose: onCloseIMG,
	} = useDisclose();
	const { colors } = useTheme();
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [isValidated, setIsValidated] = useState(false);
	const [showDate, setShowDate] = useState(false);
	const [claim, setClaim] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);

	const theme = {
		rainbow: {
			palette: {
				brand: colors.primary["400"],
			},
		},
	};

	const route = useRoute();
	const dispatch = useDispatch();

	const Auth = useSelector((state) => state.Login.Auth);
	const Settings = useSelector((state) => state.setting.Settings);
	const page = useSelector((state) => state.Page.Pages);
	const isPageLoading = useSelector((state) => state.Page.loading);

	const today = new Date();
	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - Number(Settings.SUBMISSION_PERIOD));

	const TwoWeeksBack = yesterday.toISOString().substring(0, 10);

	const handlePressBrowseFile = async (datatype_label) => {
		let file = await DocumentPicker.getDocumentAsync({
			type: ["image/jpeg", "application/pdf", "image/png"],
		});

		if (Platform.OS !== "web") {
			let fileBase64 = await FileSystem.readAsStringAsync(file.uri, {
				encoding: "base64",
			});

			file = { ...file, uri: await fileBase64 };

			setClaim({ ...claim, [datatype_label]: file });
			InfoToast("Your file has been attached");
		} else {
			setClaim({ ...claim, [datatype_label]: file });
			InfoToast("Your file has been attached");
		}
	};

	useEffect(() => {
		setIsValidated(false);
		let ID = Auth.profile.data.filter(
			(profile) => profile.type_name === "id_passport_number"
		)[0]?.data_text;

		let storemember_guid = Auth.storemember_guid;

		if (Auth?.profile?.stores?.length === 1) {
			setClaim({
				...claim,
				ID,
				storemember_guid,
				store_guid: route.params?.store_guid,
				productclaim_guid: route.params?.productclaim_guid,
				transaction_date: route.params?.transaction_date,
				device_serial: route.params?.product?.map(
					(product) => product.data_text
				)[0],
			});
		} else {
			setClaim({
				...claim,
				ID,
				storemember_guid,
				transaction_date: route.params?.transaction_date,
				device_serial: route.params?.product?.map(
					(product) => product.data_text
				)[0],
			});
		}
	}, [route]);

	const handleSubmitDispute = async () => {
		try {
			Validate();

			setIsSubmitting(true);

			let claimRes = await disputeClaim(
				claim,
				route.params?.productclaim_guid,
				Auth.session_token
			);

			if (claimRes?.data.result) {
				SuccessToast("Dispute successfully submitted", "Dispute Claim");
				setClaim({});
				setIsSubmitting(false);
				navigation.navigate("My History");
			}
		} catch (error) {
			setIsSubmitting(false);
			if (error.data?.error) {
				ErrorToast(error.data.error, "Dispute Claim");
			} else {
				ErrorToast(error.message, "Dispute Claim");
			}
		}
	};

	const onChange = (value, label = null) => {
		if (Platform.OS !== "web" && label === "transaction_date") {
			let date = new Date(value).toISOString().substring(0, 10);

			setClaim({
				...claim,
				[label]: date,
			});
		} else if (value?.target?.value) {
			setClaim({
				...claim,
				[label]: value.target.value,
			});
		} else {
			setClaim({
				...claim,
				[label]: value,
			});
		}
	};

	const onCapture = async (photo, datatype_name) => {
		let date = new Date().toISOString().substring(0, 10).split("-").join("");
		let time = new Date().toISOString().substring(11, 19).split(":").join("");
		let img = {
			...photo,
			mimeType: "application/jpg",
			name: `IMG_${date}_${time}.jpg`,
		};

		let fileBase64 = await FileSystem.readAsStringAsync(img.uri, {
			encoding: "base64",
		});

		img = { ...img, uri: await fileBase64 };

		setClaim({
			...claim,
			[datatype_name]: img,
		});
		onClose();
	};

	const onBarCodeScan = async (data, datatype_name) => {
		setClaim({
			...claim,
			[datatype_name]: data,
		});
		onCloseBarCode();
	};

	const Validate = () => {
		let Errors = [];

		if (!claim["store_guid"]) {
			Errors = {
				...Errors,
				["store_guid"]: "Please select a store",
			};
		}

		if (!claim["transaction_date"]) {
			Errors = {
				...Errors,
				["transaction_date"]: "Please select a date",
			};
		}

		if (!claim["attachment_proof_of_sale"]) {
			Errors = {
				...Errors,
				["attachment_proof_of_sale"]: "Please attach proof of sale",
			};
		}

		if (!claim["device_serial"]) {
			Errors = {
				...Errors,
				["device_serial"]: "Please provide IMEI/Serial number",
			};
		}

		if (Object.keys(Errors).length > 0) {
			Object.keys(Errors).map((key, index) => {
				throw new Error(Errors[key]);
			});
		}
	};

	return (
		<>
			{isPageLoading ? (
				<Loader />
			) : (
				<ScrollView>
					<Box bg="#fff" padding="20px" borderRadius="5px" flex="3">
						<FormControl isRequired>
							<Stack mx="3" space={2.5}>
								{Constants.CIP_BRAND === Constants.XiaomiURL && (
									<View style={{ alignItems: "center" }}>
										<Text fontSize={12} italic>
											Dispute all claims within 7 days
										</Text>
									</View>
								)}
								{page[0]?.children_components.map((control, index) => {
									switch (control.componenttype_name) {
										case "INPUT":
											if (
												control?.sitepagecomponent_meta?.options &&
												control?.sitepagecomponent_meta?.options?.length > 0
											) {
												return (
													<View key={index}>
														<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
														<Select
															// minWidth={
															// 	control.datatype_label === "Store"
															// 		? "70%"
															// 		: "full"
															// }
															size="md"
															onValueChange={(value) =>
																onChange(value, control.datatype_name)
															}
															// onValueChange={(value) => onChannelChange(value)}
															name={`${control.datatype_label}`}
															selectedValue={claim[control.datatype_name]}
															placeholder={` Select Channel/Group...`}
														>
															{Object.keys(
																control.sitepagecomponent_meta.relations
																	?.channel
															).map((key, index) => {
																return (
																	<Select.Item
																		key={key}
																		label={
																			control.sitepagecomponent_meta.relations
																				?.channel[key]
																		}
																		value={key}
																	/>
																);
															})}
														</Select>
													</View>
												);
											} else if (control.sitepagecomponent_meta.attributes) {
												if (
													control.sitepagecomponent_meta.attributes.type ===
													"file"
												) {
													return (
														<View key={control.sitepagecomponent_guid}>
															<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
															<View
																style={{
																	justifyContent: "space-around",
																}}
															>
																{isWeb() ? (
																	<>
																		<Button
																			// bgColor={colors.primary}
																			style={
																				isDesktopOrLaptop[0]
																					? {
																							marginRight: "auto",
																							marginLeft: "auto",
																					  }
																					: {}
																			}
																			onPress={() =>
																				handlePressBrowseFile(
																					control.datatype_name
																				)
																			}
																			leftIcon={
																				<Icon
																					as={Ionicons}
																					name="cloud-upload-outline"
																					size="sm"
																				/>
																			}
																		>
																			Upload Attachment
																		</Button>
																		{claim[control.datatype_name]?.uri && (
																			<View
																				style={{
																					// flexDirection: "row",
																					justifyContent: "space-between",
																				}}
																			>
																				<Text color="primary.300">
																					{claim[control.datatype_name]?.name}
																				</Text>
																				<Image
																					resizeMode="contain"
																					source={{
																						uri: claim[control.datatype_name]
																							?.uri,
																					}}
																					style={{
																						width: 100,
																						height: 100,
																						resizeMode: "contain",
																					}}
																				/>
																			</View>
																		)}
																	</>
																) : (
																	<>
																		<Input
																			value={claim[control.datatype_name]?.name}
																			isReadOnly={true}
																			multiline={true}
																			numberOfLines={2}
																			type="text"
																			padding="2"
																			placeholder={control.datatype_label}
																			InputRightElement={
																				<IconButton
																					onPress={onOpen}
																					size="md"
																					_icon={{
																						as: MaterialIcons,
																						name: "camera-alt",
																						color: "primary.500",
																						size: "md",
																					}}
																				/>
																			}
																			InputLeftElement={
																				<IconButton
																					onPress={() =>
																						handlePressBrowseFile(
																							control.datatype_name
																						)
																					}
																					size="md"
																					_icon={{
																						as: MaterialIcons,
																						name: "photo",
																						color: "primary.500",
																						size: "md",
																					}}
																				/>
																			}
																		/>
																		{claim[control.datatype_name]?.uri && (
																			<>
																				<TouchableOpacity onPress={onOpenIMG}>
																					<Image
																						resizeMode="contain"
																						source={{
																							uri: `data:image/jpeg;base64,${
																								claim[control.datatype_name]
																									?.uri
																							}`,
																						}}
																						style={{
																							width: 200,
																							height: 100,
																							marginTop: 10,
																							resizeMode: "stretch",
																						}}
																					/>
																				</TouchableOpacity>
																				<Actionsheet
																					isOpen={isOpenIMG}
																					onClose={onCloseIMG}
																				>
																					<Actionsheet.Content
																						style={{
																							height: height / 1.3,
																							// backgroundColor: "transparent",
																						}}
																					>
																						<Image
																							resizeMode="contain"
																							source={{
																								uri: `data:image/jpeg;base64,${
																									claim[control.datatype_name]
																										?.uri
																								}`,
																							}}
																							style={{
																								width: height / 1.8,
																								height: height / 1.2,

																								resizeMode: "stretch",
																							}}
																						/>
																					</Actionsheet.Content>
																				</Actionsheet>
																			</>
																		)}
																	</>
																)}
															</View>
															<Actionsheet
																isOpen={isOpen}
																onClose={onClose}
																hideDragIndicator={true}
															>
																<Actionsheet.Content
																	style={{ height: height / 1.3 }}
																>
																	<AppCamera
																		onClose={onClose}
																		onCapture={onCapture}
																		datatype_name={control.datatype_name}
																	/>
																</Actionsheet.Content>
															</Actionsheet>
														</View>
													);
												} else if (
													control.sitepagecomponent_meta.attributes.type ===
													"textarea"
												) {
													return (
														<View key={control.sitepagecomponent_guid}>
															<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
															<FormControl.HelperText
																_text={{ fontSize: "xs" }}
															>
																{control.sitepagecomponent_meta?.helptext}
															</FormControl.HelperText>

															{isWeb() ? (
																<Input
																	value={claim[control.datatype_name]}
																	numberOfLines={10}
																	multiline={true}
																	isDisabled={true}
																	onChangeText={(value) =>
																		onChange(value, control.datatype_name)
																	}
																	h={20}
																	placeholder={`${control.sitepagecomponent_meta?.placeholder}`}
																	w={{
																		base: isDesktopOrLaptop[0] ? "25%" : "80%",
																		md: isDesktopOrLaptop[0] ? "25%" : "80%",
																	}}
																	height={100}
																/>
															) : (
																<>
																	<Input
																		onChangeText={(value) =>
																			onChange(value, control.datatype_name)
																		}
																		value={claim[control.datatype_name]}
																		isDisabled={true}
																		height={100}
																		numberOfLines={10}
																		multiline={true}
																		type="text"
																		padding="2"
																		placeholder={control.datatype_label}
																	/>
																	<Actionsheet
																		isOpen={isOpenBarCode}
																		onClose={onCloseBarCode}
																		hideDragIndicator={true}
																	>
																		<Actionsheet.Content
																			style={{ height: height / 1.3 }}
																		>
																			<AppScanCamera
																				onClose={onCloseBarCode}
																				onCapture={onBarCodeScan}
																				datatype_name={control.datatype_name}
																			/>
																		</Actionsheet.Content>
																	</Actionsheet>
																</>
															)}
														</View>
													);
												} else if (
													control.sitepagecomponent_meta.attributes.type ===
													"date"
												) {
													return (
														<View key={control.sitepagecomponent_guid}>
															<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
															{isWeb() ? (
																// <div className="rainbow-m-around_small datepicker">
																<Application theme={theme}>
																	<DatePicker
																		onChange={(value) =>
																			onChange(
																				dayjs(value).format("YYYY-MM-DD"),
																				control.datatype_name
																			)
																		}
																		value={
																			claim[control.datatype_name]
																				? new Date(claim[control.datatype_name])
																				: null
																		}
																		placehplaceholder={`${control.datatype_label}`}
																		formatStyle="medium"
																		minDate={new Date(TwoWeeksBack)}
																		maxDate={new Date()}
																		locale="en-ZA"
																		style={{
																			fontFamily: "NotoSans-Regular",
																			fontSize: 10,
																		}}
																	/>
																</Application>
															) : (
																// </div>
																<>
																	<Input
																		onPressIn={() => setShowDate(true)}
																		onChangeText={(value) =>
																			onChange(value, control.datatype_name)
																		}
																		showSoftInputOnFocus={false}
																		value={claim[control.datatype_name]}
																		type="text"
																		InputRightElement={
																			<IconButton
																				size="sm"
																				onPress={() => setShowDate(true)}
																				_icon={{
																					as: Ionicons,
																					name: "calendar",
																					color: "primary.500",
																					size: "sm",
																				}}
																			></IconButton>
																		}
																		// isDisabled={true}
																		placeholder={`${control.datatype_label} format YYYY-MM-DD`}
																	/>
																	{showDate && (
																		<DateTimePicker
																			maximumDate={new Date()}
																			minimumDate={new Date(TwoWeeksBack)}
																			mode="date"
																			is24Hour={true}
																			display="default"
																			value={
																				claim[control.datatype_name]
																					? new Date(
																							claim[control.datatype_name]
																					  )
																					: new Date()
																			}
																			onChange={(event, value) => {
																				onChange(value, control.datatype_name);
																				setShowDate(false);
																			}}
																		/>
																	)}
																</>
															)}
														</View>
													);
												}
											} else {
												if (control.datatype_label === "Linked Store") {
													return (
														<View>
															<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
															<Select
																// minWidth={
																// 	control.datatype_label === "Store"
																// 		? "70%"
																// 		: "full"
																// }
																onValueChange={(value) =>
																	onChange(value, control.datatype_name)
																}
																name={`${control.datatype_label}`}
																selectedValue={claim[control.datatype_name]}
																placeholder={` Select ${control.datatype_label}`}
															>
																{Auth?.profile?.stores.map((store, index) => {
																	return (
																		<Select.Item
																			key={index}
																			label={store.store_name}
																			value={store.store_guid}
																		/>
																	);
																})}
															</Select>
														</View>
													);
												}

												let controlType = "text";
												let showHelper = false;
												if (
													control.datatype_label
														.toLowerCase()
														.includes("cellphone")
												) {
													showHelper = true;
												}
												if (
													control.datatype_label.toLowerCase().includes("email")
												) {
													controlType = "email";
												} else if (
													control.datatype_label
														.toLowerCase()
														.includes("password")
												) {
													controlType = "password";
												}

												return (
													<View key={control.sitepagecomponent_guid}>
														<FormControl.Label>{`${control.datatype_label}`}</FormControl.Label>
														<Input
															onChangeText={(value) =>
																onChange(value, control.datatype_name)
															}
															secureTextEntry={
																controlType == "password" ? true : false
															}
															placeholder={`${control.datatype_label}`}
															label={`${control.datatype_label}`}
															value={claim[control.datatype_name]}
														/>
														{showHelper && (
															<FormControl.HelperText
																_text={{ fontSize: "xs" }}
															>
																{control.sitepagecomponent_meta.input_notice}
															</FormControl.HelperText>
														)}
													</View>
												);
											}
											break;
										case "BUTTON":
											switch (control.sitepagecomponent_meta.label) {
												case "Dispute Claim":
													return (
														<Button
															onPress={handleSubmitDispute}
															isLoading={isSubmitting}
															isLoadingText="Submitting"
															variant={isSubmitting ? "outline" : "solid"}
															style={
																isDesktopOrLaptop[0]
																	? {
																			marginLeft: "auto",
																	  }
																	: {}
															}
															leftIcon={
																<Icon
																	as={FontAwesome}
																	name={
																		control.sitepagecomponent_meta.attributes
																			.icon
																	}
																	size="sm"
																/>
															}
														>
															{`${control.sitepagecomponent_meta.label}`}
														</Button>
													);

												default:
													break;
											}

										default:
											break;
									}
								})}
							</Stack>
						</FormControl>
					</Box>
				</ScrollView>
			)}
		</>
	);
};

export default DisputeClaim;
